<template>
  <div>
    <b-row>
      <b-col>
        <InputSelect
          title="Option Format"
          name="type"
          isRequired
          v-model="button.ButtonTypeId"
          :options="typeOptions"
          valueField="id"
          textField="name"
          @onDataChange="handleChangeType"
        />
      </b-col>

      <b-col>
        <InputText
          textFloat="Sort Order"
          v-model="button.SortOrder"
          placeholder="Sort Order"
          type="number"
          name="sortOrder"
        />
      </b-col>
      <b-col v-if="button.ButtonTypeId == 1">
        <InputSelect
          title="Style"
          name="style"
          v-model="button.Style"
          :options="buttonStyleList"
          valueField="id"
          textField="name"
          @onDataChange="handleChangeStyle"
        />
      </b-col>
    </b-row>
    <!-- <b-row class="">
      <b-col>
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-radio
            v-model="button.IsDefinedFlow"
            :aria-describedby="ariaDescribedby"
            :name="'some-radios' + buttonIndex"
            :value="button.IsDefinedFlow"
          >
            New Button</b-form-radio
          >
        </b-form-group>
      </b-col>
    </b-row> -->

    <template v-if="!button.IsDefinedFlow">
      <b-row>
        <b-col>
          <InputText
            v-model="button.Label"
            textFloat="Option Name"
            placeholder="Option Name"
            type="text"
            name="text"
            isRequired
            :lightText="true"
            :maxLength="40"
            :isValidate="v.Label.$error"
            :v="v.Label"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <InputText
            v-model="button.Data"
            textFloat="Action Name/Intent Name"
            placeholder="Action Name/Intent Name"
            type="text"
            name="text"
            isRequired
            :lightText="true"
            :maxLength="40"
            :isValidate="v.Data.$error"
            :v="v.Data"
          />
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
export default {
  components: {
    InputText,
    InputSelect,
  },
  props: {
    button: {
      required: true,
      type: Object,
    },
    buttonIndex: {
      required: false,
      type: Number,
    },
    v: {
      required: true,
      type: Object,
    },
    // maxPerType: { 2: 13 },

    optionList: { type: Array, default: () => [] },
  },
  data() {
    return {
      isNewButton: false,
      buttonTypeList: [],
      buttonStyleList: [],
    };
  },
  computed: {
    typeOptions() {
      return this.buttonTypeList.map((o) => ({
        ...o,
        disabled: this.isTypeDisabled(o.id),
      }));
    },
  },
  created() {
    this.getButtonType();
    this.getButtonStyle();
  },
  methods: {
    isTypeDisabled(typeId) {
      if (typeId !== 2) {
        return;
      }
      const used = (this.optionList || []).filter(
        (b) => b && b !== this.button && b.ButtonTypeId === 2
      ).length;
      return used > 12;
    },
    async getButtonType() {
      await this.axios
        .get(`${this.$baseUrl}/masterdata/buttontype`)
        .then((data) => {
          if (data.result == 1) {
            this.buttonTypeList = data.detail.map((x) => ({
              ...x,
              disabled: false,
            }));
          }
        });
    },
    async getButtonStyle() {
      await this.axios
        .get(`${this.$baseUrl}/masterdata/ButtonStyle`)
        .then((data) => {
          if (data.result == 1) {
            this.buttonStyleList = data.detail;
          }
        });
    },
    handleChangeType(value) {
      this.button.ButtonTypeId = value;
    },
    handleChangeStyle(value) {
      this.button.Style = value;
    },
  },
};
</script>

<style lang="scss" scoped></style>
